<template>
  <div>
    <div class="sidebar">
      <div class="sidebar-title">CLIMB</div>
      <div class="sidebar-items">
        <router-link
          v-for="item in items"
          :key="item.name"
          :to="{ name: item.name }"
        >
          <div class="sidebar-item">
            <div class="sidebar-item-icon">
              <icon :icon="item.icon"></icon>
            </div>
            {{ item.title }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminNav",
  data() {
    return {
      items: [
        { title: "Início", name: "inicio", icon: "home" },
        { title: "Usuários", name: "usuarios", icon: "users" },
        { title: "Profissões", name: "profissoes", icon: "briefcase" },
        { title: "Cargos", name: "cargos", icon: "user" },
        { title: "Departamentos", name: "departamentos", icon: "building" },
        { title: "Motivos bloqueio", name: "motivos_bloqueio", icon: "ban" },
        { title: "Contatos", name: "contatos", icon: "user" }
      ]
    };
  }
};
</script>

<style lang="css" scoped>
.sidebar {
  display: flex;
  flex-direction: column;
  min-width: 220px;
  background: #2c3e50;
  color: #fff;
  height: 100vh;
}

.sidebar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #34495e;
}

.sidebar-items {
  margin-top: 15px;
}

.sidebar-items a {
  color: #fff;
  text-decoration: none;
}

.sidebar-item {
  padding: 20px 25px;
  cursor: pointer;
  font-size: 0.9em;
}

.sidebar-item:hover {
  background: #34495e;
}

.sidebar-item.selected {
  background: #34495e;
}

.sidebar-item .sidebar-item-icon {
  display: inline-block;
  width: 25px;
}

.sidebar-enter-active {
  margin-left: -220px;
  transition: 0.5s;
}

.sidebar-enter-to {
  margin-left: 0px;
}

.sidebar-leave-active {
  margin-left: 0px;
  transition: 0.5s;
}

.sidebar-leave-to {
  margin-left: -220px;
}
</style>
